import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { CiFieldService } from './service/ci-field.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { PermissionService } from 'src/app/util/services/permission/permission.service';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'register-form-ci-field',
	templateUrl: './ci-field.component.html',
	styleUrls: ['./ci-field.component.scss'],
})
export class CiFieldComponent implements OnInit {
	//Permissões de CMDB
	/*
  ?register_cmdb_field_can_edit
  register_cmdb_field_all_customers
  */

	//Permissões de CI
	/*
  register_cmdb_field_can_edit
  register_cmdb_field_all_customers
  */

	//Permissões de Customfields
	/*
  register_cmdb_field_can_edit
  register_cmdb_field_all_customers
  */

	icons = {
		faExclamationCircle: faExclamationCircle,
	};

	labels: LabelsInterface = {
		lbl_geral_selecione: 'SELECT',
		lbl_geral_nao: 'No',
		lbl_geral_sim: 'Yes',
		lbl_iac_min_char_search: '',
		lbl_asset_tipo_ci: '',
		lbl_asset_campos_extras: '',
		lbl_geral_adicionar_novo: '',
		lbl_geral_nome: '',
		lbl_geral_tipo: '',
		lbl_geral_mandatory: '',
		lbl_geral_texto: '',
		lbl_geral_numero: '',
		lbl_geral_monetario: '',
		lbl_geral_data: '',
		lbl_geral_caixa_texto: '',
		lbl_geral_periodo: '',
		lbl_explain_booleano: '',
		lbl_selecao_multipla: '',
		lbl_multiplos_campos: '',
		lbl_clientes_que_nao_utilizam_esse_campo: '',
		lbl_geral_atualizar: '',
		lbl_geral_registrar: '',
		lbl_geral_criado_com_sucesso: '',
		lbl_successful_updated: '',
		lbl_preencha_todos_asteriscos: '',
		lbl_tip_select_container_ciFieldRegister: '',
		lbl_geral_listagem: '',
		lbl_geral_excluir: '',
		lbl_removido_com_sucesso: '',
		lbl_clique_confirmar_acao: '',
		lbl_duplicar_em_outro_tipo_de_ci: '',
		lbl_desativar_campo_neste_cliente: '',
		lbl_itens_da_listagem: '',
		lbl_geral_campos_customizados: '',
		lbl_asset_inventario: '',
		lbl_geral_campos: '',
		lbl_criacao_campo_cmdb: '',
		lbl_geral_cancelar: '',
	};

	constructor(
		private CiFieldService: CiFieldService,
		private LabelsService: LabelsService,
		private NotificationService: NotificationService,
		public ProfileService: ProfileService,
		public PermissionService: PermissionService
	) {}

	isLoadingLabels = true;
	isLoadingAvailableCiTypes = true;
	isLoadingCiFields = false;

	isUpdatingField = false;
	isCreatingField = false;
	isDeletingField = false;
	cleanValues = false;
	duplicateField = false;

	availableCiTypes: ciTypesInterface[] = [];

	fieldLevel: 'cmdb' | 'ci' | 'customfield';

	ciFields: genericFormInterface[] = [];
	ciFieldsIAC: iacOptionInterface[] = [];

	labelLoad: LabelsInterface[] = [];
	labelLoadIAC: iacOptionInterface[] = [];
	availableCustomers: genericFormI[] = [];
	duplicateFields: genericFormI[] = [];

	multiInputForm: genericFormI<'multi-input'>[] = [
		{
			id: '',
			label: 'Subcampos',
			name: 'Subcampos',
			inputType: 'multi-input',
			items: [
				{
					label: 'lbl_geral_nome',
					name: 'subFieldName',
					inputType: 'string',
					values: [''],
				},
				{
					label: 'Label',
					name: 'subFieldLabel',
					inputType: 'string',
					values: [''],
				},
				{
					label: 'lbl_geral_tipo',
					name: 'subFieldType',
					inputType: 'select',
					values: [''],
					items: [
						{ name: 'string', label: 'lbl_geral_texto', values: ['string'] },
						{ name: 'number', label: 'lbl_geral_numero', values: ['number'] },
						{ name: 'money', label: 'lbl_geral_monetario', values: ['money'] },
						{ name: 'date', label: 'lbl_geral_data', values: ['date'] },
						{ name: 'select', label: 'lbl_geral_listagem', values: ['select'] },
						{ name: 'bit', label: 'lbl_explain_booleano', values: ['bit'] },
					],
				},
				{
					label: 'lbl_geral_obrigatorio',
					name: 'required',
					inputType: 'select',
					values: [0],
					items: [
						{ name: 'no', label: 'lbl_geral_nao', values: ['0'] },
						{ name: 'yes', label: 'lbl_geral_sim', values: ['1'] },
					],
				},
			],
			filterValues: [],
			values: [],
			rawValues: [],
		},
	];

	selectedCiType = '';
	selectedField: genericFormInterface = {
		id: '-1',
		label: '',
		name: '',
		required: false,
		inputType: '',
		items: [],
		showOnCustomer: [],
		autoWriteFields: [],
		values: [''],
		subfield_items: [],
	};

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.LabelsService.getLabelLoad().subscribe((labelLoad) => {
			this.labelLoad = labelLoad;

			for (const label of this.labelLoad) {
				const labelIAC: iacOptionInterface = {
					name: 'lbl_' + label.id,
					secondName: label[this.ProfileService.userData().language],
					value: 'lbl_' + label.id,
					commonGroup: label[this.ProfileService.userData().language],
				};

				this.labelLoadIAC.push(labelIAC);
			}
		});

		this.ProfileService.getAvailableCustomers().subscribe((availableCustomers) => {
			const newGenericForm = new genericFormI('multi-select');
			newGenericForm['name'] = 'cmdb_field_show';
			newGenericForm['label'] = 'lbl_campo_ativo_clientes';

			for (const customer of availableCustomers) {
				const newItem = new genericFormI('item');
				newItem['name'] = customer.customer;
				((newItem['label'] = customer.customer), (newItem['values'] = [customer.id]));
				newItem['rawValues'] = [customer.id];

				newGenericForm.items.push(newItem);
			}

			this.availableCustomers = [newGenericForm];
		});

		this.CiFieldService.getAvailableCiTypes().subscribe(
			(availableCiTypes) => {
				this.availableCiTypes = availableCiTypes;

				const newDuplicateField = new genericFormI('multi-select');
				newDuplicateField['name'] = 'cmdb_default_fields_hide';
				newDuplicateField['label'] = 'lbl_clientes_que_nao_utilizam_esse_campo';

				for (const ciType of availableCiTypes) {
					const newItem = new genericFormI('item');
					newItem['name'] = ciType.name;
					((newItem['label'] = ciType.label), (newItem['values'] = [ciType.id]));
					newItem['rawValues'] = [ciType.id];

					newDuplicateField.items.push(newItem);
				}

				this.duplicateFields = [newDuplicateField];

				this.isLoadingAvailableCiTypes = false;
			},
			() => {
				this.isLoadingAvailableCiTypes = false;
			}
		);
	}

	getCiFields(): void {
		if (this.isLoadingCiFields) return;

		this.isLoadingCiFields = true;

		this.CiFieldService.getCiFields(this.selectedCiType, this.fieldLevel).subscribe(
			(ciFields) => {
				this.ciFields = ciFields;
				this.ciFieldsIAC = [];

				for (const field of this.ciFields) {
					const newIAC: iacOptionInterface = {
						name: this.labels[field.label] ? this.labels[field.label] : field.name,
						value: field.id,
					};

					this.ciFieldsIAC.push(newIAC);
				}

				this.isLoadingCiFields = false;
			},
			() => {
				this.isLoadingCiFields = false;
			}
		);
	}

	setSelectedField(idCi: string): void {
		this.selectedField = this.ciFields.find((field) => {
			return field.id.toString() == idCi.toString();
		});
		this.availableCustomers[0].values = [];
		this.availableCustomers[0].rawValues = [];

		for (const customer of this.availableCustomers[0].items) {
			if (this.selectedField.showOnCustomer.includes(customer.rawValues[0])) {
				this.availableCustomers[0].values.push(customer);
				this.availableCustomers[0].rawValues.push(customer.values[0]);
			}
		}

		this.multiInputForm[0].values = this.selectedField.values;
		this.multiInputForm[0].outItems = this.selectedField.values;
	}

	changeInputType(inputType: string): void {
		this.selectedField.inputType = inputType;
		this.selectedField.values = [''];
		this.selectedField.subfield_items = [];

		this.multiInputForm = [
			{
				id: '',
				label: 'Subcampos',
				name: 'Subcampos',
				inputType: 'multi-input',
				items: [
					{
						label: 'lbl_geral_nome',
						name: 'subFieldName',
						inputType: 'string',
						values: [''],
					},
					{
						label: 'Label',
						name: 'subFieldLabel',
						inputType: 'string',
						values: [''],
					},
					{
						label: 'lbl_geral_tipo',
						name: 'subFieldType',
						inputType: 'select',
						values: [''],
						items: [
							{ name: 'string', label: 'lbl_geral_texto', values: ['string'] },
							{ name: 'number', label: 'lbl_geral_numero', values: ['number'] },
							{ name: 'money', label: 'lbl_geral_monetario', values: ['money'] },
							{ name: 'date', label: 'lbl_geral_data', values: ['date'] },
							{ name: 'select', label: 'lbl_geral_listagem', values: ['select'] },
							{ name: 'bit', label: 'lbl_explain_booleano', values: ['bit'] },
						],
					},
					{
						label: 'lbl_geral_obrigatorio',
						name: 'required',
						inputType: 'select',
						values: [0],
						items: [
							{ name: 'no', label: 'lbl_geral_nao', values: ['0'] },
							{ name: 'yes', label: 'lbl_geral_sim', values: ['1'] },
						],
					},
				],
				filterValues: [],
				values: [],
				rawValues: [],
			},
		];
	}

	resetFields(): void {
		this.selectedField = {
			id: '-1',
			label: '',
			name: '',
			required: false,
			inputType: '',
			items: [],
			showOnCustomer: [],
			autoWriteFields: [],
			values: [''],
			subfield_items: [],
		};

		this.cleanValues = true;

		this.availableCustomers[0].values = [];
		this.multiInputForm[0].values = [];
		this.duplicateFields[0].values = [];
		this.duplicateField = false;

		setTimeout(() => {
			this.cleanValues = false;
		}, 10);
	}

	isAllFieldsFullfiled(): boolean {
		return (
			(this.selectedCiType != '' || this.fieldLevel === 'cmdb') &&
			this.selectedField.name != '' &&
			this.selectedField.label != '' &&
			this.selectedField.inputType != ''
		);
	}

	formatValidName(name: string): string {
		return name.replace(' ', '_').replace(/[!#$%&'()*+,.:;<=>?@^|-]/, '');
	}

	updateField(): void {
		if (this.isUpdatingField || this.isDeletingField) return;

		if (!this.isAllFieldsFullfiled()) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			return;
		}

		this.isUpdatingField = true;

		const body = {
			subfield: [],
			subfield_items: this.selectedField.subfield_items,
			ci_type: Number.parseInt(this.selectedCiType),
			field: this.selectedField.name,
			required: this.selectedField.required.toString() === 'true' ? 1 : 0,
			label: this.selectedField.label,
			showOnCustomer: this.availableCustomers[0].rawValues,
			autoWriteFields: [],
			type: this.selectedField.inputType,
			id: this.selectedField.id,
			selectOptions: this.selectedField.values,
		};

		for (const multiField of this.multiInputForm[0].values) {
			body.subfield.push({ name: multiField[0], label: multiField[1], type: multiField[2], required: multiField[3] });
		}

		if (this.duplicateField) {
			for (const [index, idCiType] of this.duplicateFields[0].values.entries()) {
				const temporaryBody = { ...body };
				temporaryBody.ci_type = idCiType.value;
				this.CiFieldService.createField(temporaryBody, 'customfield').subscribe(
					() => {},
					(errorRes) => {
						if (errorRes.error.ExtendedInfo != undefined) {
							this.NotificationService.setNotificationMessage(
								this.labels[this.duplicateField[0].values[index].label] + ': ' + this.labels[errorRes.error.ExtendedInfo]
							);
						}
					}
				);
			}
			this.duplicateFields[0].values = [];
		}

		this.CiFieldService.updateField(body, this.fieldLevel).subscribe(
			(res) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
				this.isUpdatingField = false;
			},
			(errorRes) => {
				if (errorRes.error.ExtendedInfo != undefined) {
					this.NotificationService.setNotificationMessage(this.labels[errorRes.error.ExtendedInfo]);
				}
				this.isUpdatingField = false;
			}
		);
	}

	createField(): void {
		if (this.isCreatingField) return;

		if (!this.isAllFieldsFullfiled()) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			return;
		}

		this.isCreatingField = true;

		const body = {
			subfield: [],
			subfield_items: this.selectedField.subfield_items,
			ci_type: Number.parseInt(this.selectedCiType),
			field: this.selectedField.name,
			required: this.selectedField.required.toString() === 'true' ? 1 : 0,
			label: this.selectedField.label,
			showOnCustomer: [],
			autoWriteFields: [],
			type: this.selectedField.inputType,
			selectOptions: this.selectedField.values,
		};

		for (const ignoredCustomer of this.availableCustomers[0].values) {
			body.showOnCustomer.push(ignoredCustomer.value);
		}

		for (const multiField of this.multiInputForm[0].values) {
			body.subfield.push({ name: multiField[0], label: multiField[1], type: multiField[2], required: multiField[3] });
		}

		this.CiFieldService.createField(body, this.fieldLevel).subscribe(
			(res) => {
				this.selectedField.id = res.message;
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_criado_com_sucesso);
				this.isCreatingField = false;
			},
			(errorRes) => {
				if (errorRes.error.ExtendedInfo != undefined) {
					this.NotificationService.setNotificationMessage(this.labels[errorRes.error.ExtendedInfo]);
				}
				this.isCreatingField = false;
			}
		);
	}

	deleteField(): void {
		if (this.isDeletingField || this.isUpdatingField) return;

		this.isDeletingField = true;
		this.CiFieldService.deleteField(this.selectedCiType, this.fieldLevel, this.selectedField.id).subscribe(
			() => {
				this.getCiFields();
				this.resetFields();
				this.isDeletingField = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_removido_com_sucesso);
			},
			() => {
				this.isDeletingField = false;
			}
		);
	}

	confirmButton(elementReference: HTMLElement): void {
		this.NotificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirmClick');
		setTimeout(() => {
			elementReference.classList.remove('confirmClick');
		}, 5000);
	}
}
